<!-- Floating Chat Button -->
<div class="chatbot-container">
  <!-- Chat Button -->
  <div class="chat-button" 
       [class.active]="isOpen" 
       (click)="toggleChat()"
       *ngIf="!isOpen">
    <div class="chat-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="currentColor"/>
        <circle cx="7" cy="9" r="1" fill="currentColor"/>
        <circle cx="12" cy="9" r="1" fill="currentColor"/>
        <circle cx="17" cy="9" r="1" fill="currentColor"/>
      </svg>
    </div>
    <div class="chat-pulse"></div>
  </div>

  <!-- Chat Window -->
  <div class="chat-window" 
       [class.open]="isOpen" 
       [class.minimized]="isMinimized"
       [class.rtl]="userInfo.language === 'ar'">
    
    <!-- Chat Header -->
    <div class="chat-header">
      <div class="chat-header-info">
        <div class="bot-avatar">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V19C3 20.1 3.9 21 5 21H11V19H5V3H13V9H21Z" fill="currentColor"/>
          </svg>
        </div>
        <div class="chat-title">
          <h4>{{ userInfo.language === 'ar' ? 'المساعد الذكي' : 'AI Assistant' }}</h4>
          <span class="status">{{ userInfo.language === 'ar' ? 'متصل' : 'Online' }}</span>
        </div>
      </div>
      <div class="chat-controls">
        <button class="control-btn minimize-btn" (click)="minimizeChat()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 13H5V11H19V13Z" fill="currentColor"/>
          </svg>
        </button>
        <button class="control-btn close-btn" (click)="closeChat()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Chat Messages -->
    <div class="chat-messages" 
         #messagesContainer
         [class.minimized]="isMinimized"
         (scroll)="onScroll()">
      
      <div class="message" 
           *ngFor="let message of messages; trackBy: trackByMessageId"
           [class.user-message]="message.isUser"
           [class.bot-message]="!message.isUser">
        
        <div class="message-avatar" *ngIf="!message.isUser">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V19C3 20.1 3.9 21 5 21H11V19H5V3H13V9H21Z" fill="currentColor"/>
          </svg>
        </div>
        
        <div class="message-content">
          <div class="message-bubble" *ngIf="!message.stockDetail">
            {{ message.text }}
          </div>

          <!-- Registration Form Card -->
          <div class="registration-form" *ngIf="message.registrationForm" [dir]="userInfo.language === 'ar' ? 'rtl' : 'ltr'">
            <div class="form-group">
              <label for="reg-name">{{ userInfo.language === 'ar' ? 'الاسم بالكامل' : 'Full Name' }} <span class="required">*</span></label>
              <input 
                id="reg-name"
                type="text" 
                [(ngModel)]="userInfo.name" 
                [placeholder]="userInfo.language === 'ar' ? 'أدخل اسمك بالكامل' : 'Enter your full name'"
                [class.error]="registrationErrors.name"
                class="form-control">
              <span class="error-msg" *ngIf="registrationErrors.name">{{ registrationErrors.name }}</span>
            </div>
            
            <div class="form-group">
              <label for="reg-phone">{{ userInfo.language === 'ar' ? 'رقم الهاتف' : 'Phone Number' }} <span class="required">*</span></label>
              <input 
                id="reg-phone"
                type="tel" 
                [(ngModel)]="userInfo.phone" 
                [placeholder]="userInfo.language === 'ar' ? 'أدخل رقم الهاتف' : 'Enter your phone number'"
                [class.error]="registrationErrors.phone"
                class="form-control">
              <span class="error-msg" *ngIf="registrationErrors.phone">{{ registrationErrors.phone }}</span>
            </div>
            
            <div class="form-group">
              <label for="reg-email">{{ userInfo.language === 'ar' ? 'البريد الإلكتروني (اختياري)' : 'Email (Optional)' }}</label>
              <input 
                id="reg-email"
                type="email" 
                [(ngModel)]="userInfo.email" 
                [placeholder]="userInfo.language === 'ar' ? 'أدخل البريد الإلكتروني (اختياري)' : 'Enter email address (optional)'"
                [class.error]="registrationErrors.email"
                class="form-control">
              <span class="error-msg" *ngIf="registrationErrors.email">{{ registrationErrors.email }}</span>
            </div>
            
            <button class="submit-btn" (click)="submitRegistrationForm(message)">
              {{ userInfo.language === 'ar' ? 'تسجيل' : 'Register' }}
            </button>
          </div>

          <!-- Stock Detail Card -->
          <div class="stock-card" *ngIf="message.stockDetail">
            <div class="stock-name">{{ message.stockDetail.name }}</div>
            <div class="stock-line">
              <span class="label">{{ userInfo.language === 'ar' ? messages_ar.stockPrice : messages_en.stockPrice }}</span>
              <span class="value">{{ message.stockDetail.price }}</span>
            </div>
            <div class="stock-line">
              <span class="label">{{ userInfo.language === 'ar' ? messages_ar.stockChange : messages_en.stockChange }}</span>
              <span class="value" [class.positive]="message.stockDetail.isPositiveChange === true" [class.negative]="message.stockDetail.isPositiveChange === false">
                {{ message.stockDetail.changeValue }}
              </span>
            </div>
            <div class="stock-line" *ngIf="message.stockDetail.changePercent != null">
              <span class="label">%</span>
              <span class="value" [class.positive]="message.stockDetail.isPositiveChange === true" [class.negative]="message.stockDetail.isPositiveChange === false">
                {{ message.stockDetail.changePercent }}%
              </span>
            </div>
            <div class="stock-line" *ngIf="message.stockDetail.volume != null">
              <span class="label">{{ userInfo.language === 'ar' ? messages_ar.stockVolume : messages_en.stockVolume }}</span>
              <span class="value">{{ message.stockDetail.volume }}</span>
            </div>
            <div class="stock-line" *ngIf="message.stockDetail.high != null">
              <span class="label">{{ userInfo.language === 'ar' ? messages_ar.stockHigh : messages_en.stockHigh }}</span>
              <span class="value">{{ message.stockDetail.high }}</span>
            </div>
            <div class="stock-line" *ngIf="message.stockDetail.low != null">
              <span class="label">{{ userInfo.language === 'ar' ? messages_ar.stockLow : messages_en.stockLow }}</span>
              <span class="value">{{ message.stockDetail.low }}</span>
            </div>
            <div class="stock-line" *ngIf="message.stockDetail.open != null">
              <span class="label">{{ userInfo.language === 'ar' ? messages_ar.stockOpen : messages_en.stockOpen }}</span>
              <span class="value">{{ message.stockDetail.open }}</span>
            </div>
            <div class="stock-line" *ngIf="message.stockDetail.previousClose != null">
              <span class="label">{{ userInfo.language === 'ar' ? messages_ar.stockPreviousClose : messages_en.stockPreviousClose }}</span>
              <span class="value">{{ message.stockDetail.previousClose }}</span>
            </div>
          </div>
          
          <!-- Quick Options -->
          <div class="quick-options" *ngIf="message.options && message.options.length > 0">
            <button 
              *ngFor="let option of message.options" 
              class="quick-option-btn"
              (click)="selectOption(option)"
              [dir]="userInfo.language === 'ar' ? 'rtl' : 'ltr'">
              {{ option.text }}
            </button>
          </div>
          
          <div class="message-time">
            {{ message.timestamp | date:'short' }}
          </div>
        </div>
      </div>

      <!-- Language Selection Buttons -->
      <div class="language-selection" *ngIf="shouldShowLanguageButtons">
        <div class="language-buttons">
          <button class="language-btn english-btn" (click)="selectLanguage('en')">
            <span class="flag">🇺🇸</span>
            <span class="lang-text">English</span>
          </button>
          <button class="language-btn arabic-btn" (click)="selectLanguage('ar')">
            <span class="flag">🇸🇦</span>
            <span class="lang-text">العربية</span>
          </button>
        </div>
      </div>

      <!-- Typing Indicator -->
      <div class="message bot-message typing-message" *ngIf="isTyping">
        <div class="message-avatar">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V19C3 20.1 3.9 21 5 21H11V19H5V3H13V9H21Z" fill="currentColor"/>
          </svg>
        </div>
        <div class="message-content">
          <div class="message-bubble typing-bubble">
            <div class="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chat Input -->
    <div class="chat-input" [class.minimized]="isMinimized">
      <div class="input-container">
        <textarea 
          [(ngModel)]="currentMessage"
          (keydown)="onKeyPress($event)"
          [placeholder]="userInfo.language === 'ar' ? 'اكتب رسالتك...' : 'Type your message...'"
          [dir]="userInfo.language === 'ar' ? 'rtl' : 'ltr'"
          rows="1"
          class="message-input"></textarea>
        <button class="send-button" 
                (click)="sendMessage()"
                [disabled]="!currentMessage.trim()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
